module.exports = __webpack_public_path__ + "static/media/amazon.c2e99f0b.svg";